import * as constants from '../../common/constants';
import {mapGetters, mapState} from 'vuex';
import VanguardConfig from '../../../config/vanguard';
import {Severity} from '@sentry/browser';
import Order from '@/common/mixins/order';
import MixinCookies from '@/common/mixins/cookies';
import Utils from '../../common/modules/utils';

export default {
  mixins: [Order, MixinCookies],
  data: () => ({
    validatedEmailDraftData: null
  }),
  computed: {
    ...mapState({
      choiceList: state => state.choiceList
    }),
    Utils() {
      return Utils;
    },
    ...mapGetters([
      'trackingCode',
      'paymentMethod',
      'choices',
      'paymentId',
      'currentOrderUid',
      'walletUid',
      'isAspspEligibleSepa',
      'isAspspEligibleBankCard',
      'isAspspEligible',
      'cancelPreviousOrder',
      'previousExternalOrderId',
      'externalPartnerId',
      'recurrence',
      'orderComplete',
      'getSelectedChoices'
    ])
  },
  methods: {
    sendOrderData(isCancel = false) {
      // Retrieve order type, to perform the appropriate action later
      const orderType = isCancel ? constants.ORDER_STEP_CANCEL : constants.ORDER_STEP_INITIAL;

      let sendOrder;
      let message;

      // Dispatch action to the appropriate method
      switch (orderType) {
        case constants.ORDER_STEP_INITIAL:
          // Prepare callback to send order when already check is complete
          sendOrder = () => {
            if (orderType === constants.ORDER_STEP_INITIAL && this.journeyConfig.orderFormType === constants.ORDER_FORM_TYPE_CHOICE_LIST) {
              this.enqueueRegularOrder();
            } else {
              this.prepareRegularOrderData(orderType).then(data => {
                this.sendRegularOrderData(orderType, data);
              });
            }
          };

          // For a regular order form, when we send order draft, do not perform already check
          if (this.journeyConfig.orderFormType === constants.ORDER_FORM_TYPE_CHOICE_LIST && !this.orderComplete) {
            // If emails are equal => send
            // If emails change => send
            // Else => dont send
            sendOrder();
          } else if (this.journeyConfig.orderFormType === constants.ORDER_FORM_TYPE_CHOICE_LIST_1CLICK || this.orderComplete) {
            sendOrder();
          }

          return;
        case constants.ORDER_STEP_CANCEL:
          this.sendUpdatePreviousOrder(isCancel);
          return;
        default:
          message = 'Unknown orderType';
          this.$log.error(message, orderType);
          this.sendSentryLog(
            Severity.Fatal,
            'Unknown orderType',
            {orderType}, null, false);
      }
    },

    getOrderDataAction() {
      return this.journeyConfig.orderFormType === constants.ORDER_FORM_TYPE_CHOICE_LIST ?
        'create' : 'createOneClick';
    },

    orderConfirmation() {
      this.storeCookiesBeforeRedirectingToConfirmPage();

      if ((this.isAspspEligibleSepa && this.currentChoiceConfig.paymentMethod === constants.PAYMENT_METHOD_SEPA) || (this.isAspspEligibleBankCard && this.currentChoiceConfig.paymentMethod === constants.PAYMENT_METHOD_BANK_CARD)) {
        this.redirectToWaitingDoubleOptinPage();
      } else {
        this.redirectToConfirmPage();
      }
    },

    redirectToConfirmPage() {
      // Try to retreive the nextStepCode from the main choice (with configured next step)
      const mainChoice = this.localConfig.choices.find(item => item.stackLetter === this.choiceList[0] && item.nextStepCode !== null);
      if (typeof mainChoice === 'undefined') {
        this.$log.error('Unable to retrieve next step from current choice');
        return;
      }

      let path = window.location.pathname;
      const pathElements = path.split('/');

      pathElements[2] = mainChoice.nextStepCode;
      pathElements[pathElements.length - 1] = 'index.html';

      path = pathElements.join('/');

      window.location = this.appendQueryParamsBeforeRedirection(window.location.origin + path + '?confirm=1');
    },

    async prepareRegularOrderData(orderType) {
      const orderLines = [];
      let emailContentId = 0;

      console.log('this.getSelectedChoices', this.getSelectedChoices);
      this.getSelectedChoices.forEach(choice => {
        emailContentId = choice.confirmationEmailId;

        orderLines.push({
          choice: choice.choiceId,
          choiceName: choice.name,
          amount: choice.price,
          shippingPrice: 0,
          affiliatePicklist: this.affiliateConfig.affiliateId,
          productId: choice.productId,
          allowMultiplePurchase: choice.allowMultiplePurchase
        });
      });

      const payload = {
        vanguardRevision: process.env.GIT_REVISION,
        testLevel: this.testLevel ? this.testLevel : null,
        externalOrderId: this.currentOrderUid,
        trackingCode: this.trackingCode,
        affiliatePicklist: this.affiliateConfig.affiliateId,
        ...this.formData.billing,
        ...this.formData.shipping,
        contactPolarisId: this.sfId,
        currencyIsoCode: VanguardConfig.currencyIsoCode,
        palyancePaymentId: this.paymentId,
        palyancePaymentAccountIdentifier: this.paymentAccountIdentifier,
        walletId: this.walletUid,
        aspsp: (this.isAspspEligibleSepa && this.currentChoiceConfig.paymentMethod === constants.PAYMENT_METHOD_SEPA) || (this.isAspspEligibleBankCard && this.currentChoiceConfig.paymentMethod === constants.PAYMENT_METHOD_BANK_CARD),
        isPalyanceEligible: this.isAspspEligible,
        paymentType: this.paymentMethod,
        orderLines,
        emailContentId,
        abandonEmailContentId: orderType === constants.ORDER_STEP_INITIAL ? this.journeyConfig.oaeEmailId : null,
        status: this.orderComplete ? constants.ORDER_STATUS_COMPLETED : constants.ORDER_STATUS_PENDING,
        publicationId: this.journeyConfig.publicationId,
        formCode: this.journeyConfig.orderFormCode,
        /**
         * Mindbaz params
         */
        mindbazBase: this.mbParams.base,
        mindbazCampaign: this.mbParams.campaignId,
        mindbazShoot: this.mbParams.shootId,
        mindbazSegment: this.mbParams.segmentId,
        /**
         * Marketing cloud params
         */
        marketingCloudDataSourceName: this.marketingCloudParams.marketingCloudDataSourceName,
        marketingCloudJobId: this.marketingCloudParams.marketingCloudJobId,
        marketingCloudListId: this.marketingCloudParams.marketingCloudListId,
        marketingCloudBatchId: this.marketingCloudParams.marketingCloudBatchId,
        marketingCloudSendDate: this.marketingCloudParams.marketingCloudSendDate,
        source: 'vanguard',
        orderType,
        lang: this.locale,
        externalPartnerId: this.externalPartnerId,
        previousExternalOrderId: this.previousExternalOrderId,
        url: this.generateAtlasLambdaUrl(),
        isMultipleChoice: true
      };

      // Clone data to fix its state
      return Promise.resolve(JSON.parse(JSON.stringify(payload)));
    },

    generateAtlasLambdaUrl() {
      const domainSplit = window.location.hostname.split('.');
      const domain = domainSplit[domainSplit.length - 2] + '.' + domainSplit[domainSplit.length - 1];

      const params = {
        campaignCode: this.campaignCode,
        trackingCode: this.trackingCode,
        sfId: this.sfId,
        externalPartnerId: this.externalPartnerId,
        re: window.location.protocol + '//' + window.location.host + window.location.pathname
      };

      const queryParams = Object.keys(params).map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');

      return window.location.protocol + '//atlas.' + domain + '?' + queryParams;
    }
  },
  watch: {
    formData(value) {
      // DON'T trigger order sending on 1click order forms
      if (this.journeyConfig.orderFormType !== constants.ORDER_FORM_TYPE_CHOICE_LIST) {
        return;
      }

      // Send order draft only on initial order form
      if (!this.isInitialOrderForm) {
        return;
      }

      // We send the order draft, when the billingEmailConfirm is validated in the contact-form
      // This filter avoid to send multiple requests after that each field is provided
      // We only need the email
      if (this.validatedEmailDraftData !== value.billing.billingEmailConfirm) {
        this.validatedEmailDraftData = value.billing.billingEmailConfirm;
        this.sendOrderData();
      }
    },

    paymentMethod(value) {
      // Log payment method change only for initial order form
      if (!this.isInitialOrderForm) {
        return;
      }

      this.sentry.addBreadcrumb({
        level: 'info',
        message: 'Select payment method',
        data: {
          paymentMethod: value
        }
      });
    },

    orderComplete(value) {
      if (!value) {
        return;
      }

      // When recapture is done, send nothing to Orion and don't redirect
      if (this.isRecapture) {
        return;
      }

      this.sentry.addBreadcrumb({
        level: 'info',
        message: 'Order is complete',
        data: {
          currentOrderUid: this.currentOrderUid,
          currentChoiceUid: this.currentChoiceUid,
          paymentMethod: this.paymentMethod
        }
      });

      this.sendOrderData();
    },
    cancelPreviousOrder() {
      this.sendOrderData(true);
    },
    formIsValid(value) {
      if (!this.isInitialOrderForm) {
        return;
      }

      if (!value) {
        return;
      }

      this.sentry.addBreadcrumb({
        level: 'info',
        message: 'Form is valid',
        data: this.formData
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/multiple/mixins/order.js